/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LessorStatus = {
    Active: 'ACTIVE',
    Deleted: 'DELETED'
} as const;
export type LessorStatus = typeof LessorStatus[keyof typeof LessorStatus];


export function LessorStatusFromJSON(json: any): LessorStatus {
    return LessorStatusFromJSONTyped(json, false);
}

export function LessorStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessorStatus {
    return json as LessorStatus;
}

export function LessorStatusToJSON(value?: LessorStatus | null): any {
    return value as any;
}

